import { defineStore } from 'pinia';
import { GroupAccessSettings, GroupAccessCodesRequest, GroupAccessCodesListItem } from '@front-app/services/GroupsApi/GroupAccessSettingsModel';
import { GroupsStore } from '../modules/groups';
import { GroupsStore as GlobalGroupsStore } from '../singletons/Groups';
import { Singleton } from '@front-app/util/interface';
import { updateGroupAccessSettings, getGroupAccessCodes, addGroupAccessCodes } from '@front-app/services/GroupsApi/GroupsAdmin';

interface GroupAccessStoreDependencies {
	groupsStore: Singleton<GroupsStore>;
}

interface GroupAccessStoreState {
	accessCodes: GroupAccessCodesListItem[];
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createGroupAccessStore = (name: string, dependencies: GroupAccessStoreDependencies) => defineStore(name, {
	state: (): GroupAccessStoreState => ({
		accessCodes: [],
	}),
	getters: {
		getAccessCodes(state) {
			return () => state.accessCodes;
		},
	},
	actions: {
		async changeGroupAccess(groupId: string, newSettings: GroupAccessSettings) {
			const group = await updateGroupAccessSettings(newSettings, groupId);
			dependencies.groupsStore
				.getInstance()
				.updateLocalGroup(groupId, group);
		},
		async fetchGroupAccessCodes(groupId: string) {
			const accessCodesFromApi = await getGroupAccessCodes(groupId);
			this.$patch((state: GroupAccessStoreState) => {
				state.accessCodes = accessCodesFromApi;
			});
		},
		async uploadGroupAccessCodes(groupId: string, accessCodes: GroupAccessCodesRequest) {
			const accessCodesFromApi = await addGroupAccessCodes(groupId, accessCodes);
			this.$patch((state: GroupAccessStoreState) => {
				state.accessCodes = accessCodesFromApi;
			});
		},
	},
});

export const useGroupAccessStore = createGroupAccessStore('groupAccess', {
	groupsStore: GlobalGroupsStore,
});
